module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), (_vm.user) ? _c('button', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.loginGoogle
    }
  }, [_vm._v("Login google")]), _vm._v(" "), (_vm.user) ? _c('router-link', {
    attrs: {
      "to": "/safe"
    }
  }, [_vm._v("Safe")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99a15152"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Archive/Login.vue
// module id = 305
// module chunks = 3